import React from 'react'
import { IoIosArrowBack } from "react-icons/io";
import { Link, useNavigate } from 'react-router-dom';

export default function TopBar({ 
    title, 
    url, 
    showBackButton = true, 
    rightAction = null,
    className = "",
    titleClassName = "",
    backButtonClassName = ""
}) {
    const navigate = useNavigate();

    const handleBackClick = (e) => {
        e.preventDefault();
        if (url === -1) {
            navigate(-1);
        } else {
            navigate(url);
        }
    };

    return (
        <header 
            className={`sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm ${className}`}
            role="banner"
        >
            <div className="flex items-center justify-between px-4 py-3 sm:px-6">
                {/* Left Section - Back Button */}
                <div className="flex items-center min-w-0 flex-1">
                    {showBackButton && (
                        <button
                            onClick={handleBackClick}
                            className={`
                                flex items-center justify-center w-10 h-10 rounded-full 
                                text-primary100 hover:bg-gray-100 active:bg-gray-200 
                                transition-colors duration-200 focus:outline-none 
                                focus:ring-2 focus:ring-primary100 focus:ring-opacity-50
                                ${backButtonClassName}
                            `}
                            aria-label="Go back"
                        >
                            <IoIosArrowBack className="w-6 h-6" />
                        </button>
                    )}
                </div>

                {/* Center Section - Title */}
                <div className="flex-1 flex justify-center px-4">
                    <h1 
                        className={`
                            text-lg sm:text-xl font-semibold text-gray-800 
                            text-center truncate max-w-xs sm:max-w-sm
                            ${titleClassName}
                        `}
                        title={title}
                    >
                        {title}
                    </h1>
                </div>

                {/* Right Section - Optional Action */}
                <div className="flex items-center justify-end min-w-0 flex-1">
                    {rightAction && (
                        <div className="flex items-center space-x-2">
                            {rightAction}
                        </div>
                    )}
                </div>
            </div>
        </header>
    )
}
